import axios from '../http'
import {
  CUSTOMER_ORDER,
  DELIVERED,
  EDD_ORDERS,
  EDF_ORDERS,
  PARTNER_CUSTOMER_ORDER_ACTIONS,
  ORDERS_EFFECTIVE_STATUS,
  CUSTOMER_ORDER_ACTIONS,
  DOWNLOAD,
  UPLOAD_IMAGE,
  UPLOAD_PROOF_DELIVERIES,
  REPORT_REASONS,
  EDF_DELIVERY_DOWNLOAD
} from '../endpoints'

const URLS = {
  resourceGetOrders: CUSTOMER_ORDER,
  delivery: DELIVERED,
  edd: EDD_ORDERS,
  edf: EDF_ORDERS
}

const getCustomerOrders = data => {
  const url = URLS[data.requestURL]
  let query = `${data.deliveryDateBegin},${data.deliveryDateEnd}`
  if (['resourceGetOrders', 'delivery'].includes(data.requestURL)) query = `${data.deliveryDateBegin},${data.deliveryDateEnd},${data.order}`

  const params = {
    page: `${data.page}`,
    query,
    size: 13,
    sort: `${data.sort},${data.ord}`
  }

  return axios.get(`${url}`, { params })
}

const putOrderChanges = data => axios.put(PARTNER_CUSTOMER_ORDER_ACTIONS, data)
const putEditOrdersStatus = body => axios.put(ORDERS_EFFECTIVE_STATUS, body)
const putRescheduleDateTime = body => axios.put(CUSTOMER_ORDER_ACTIONS, body)

const getDownload = data => {
  const query = `${data.deliveryDateBegin},${data.deliveryDateEnd},${data.order}`
  const params = {
    page: '-1',
    query,
    size: 10000,
    sort: `${data.sort},${data.ord}`
  }

  return axios.get(DOWNLOAD, { responseType: 'blob', params })
}

const uploadImg = body => axios.post(UPLOAD_IMAGE, body)
const uploadProofDeliveries = body => axios.post(UPLOAD_PROOF_DELIVERIES, body)
const addReschedule = body => {
  const {
    momentId,
    typeId,
    subTypeId,
    reasonId,
    customerOrdersInfo
  } = body

  let query = ''
  if (momentId) query += `${momentId}`
  if (typeId) query += `/type/${typeId}`
  if (subTypeId) query += `/subType/${subTypeId}`
  if (reasonId) query += `/reason/${reasonId}`

  return axios.post(`${REPORT_REASONS}/${query}`, customerOrdersInfo)
}

const addIncidence = body => {
  const {
    momentId,
    typeId,
    subTypeId,
    motivsId,
    customerOrdersInfo
  } = body

  let query = ''
  if (momentId) query += `${momentId}`
  if (typeId) query += `/type/${typeId}`
  if (subTypeId) query += `/subType/${subTypeId}`
  if (motivsId) query += `/reason/${motivsId}`

  return axios.post(`${REPORT_REASONS}/${query}`, customerOrdersInfo)
}

const getEdfOrders = data => {
  const {
    storeCode,
    customerOrderCode,
    supplierOrderCode,
    status,
    deliveryDateFrom,
    deliveryDateTo,
    partnerExpectedCollectionDateFrom,
    partnerExpectedCollectionDateTo,
    page,
    sort,
    ord
  } = data

  const params = {
    storeCode,
    supplierOrderCode,
    status,
    page,
    size: 13,
    sort: `${sort},${ord}`
  }

  if (!storeCode) delete params.storeCode
  if (!supplierOrderCode) delete params.supplierOrderCode
  if (!status) delete params.status

  let query = ''
  if (customerOrderCode) query += `customerOrderCode=${customerOrderCode}&`
  if (deliveryDateFrom) query += `deliveryDateFrom=${deliveryDateFrom}&deliveryDateTo=${deliveryDateTo}`
  if (partnerExpectedCollectionDateFrom) query += `partnerExpectedCollectionDateFrom=${partnerExpectedCollectionDateFrom}&partnerExpectedCollectionDateTo=${partnerExpectedCollectionDateTo}`

  return axios.get(`${EDF_ORDERS}?${query}&queryParams= `, { params })
}

const getdownloadForEdf = data => {
  const {
    storeCode,
    customerOrderCode,
    supplierOrderCode,
    status,
    deliveryDateFrom,
    deliveryDateTo,
    partnerExpectedCollectionDateFrom,
    partnerExpectedCollectionDateTo,
    sort
  } = data

  const params = {
    page: '-1',
    size: 13,
    sort: `${sort},asc`
  }

  let query = ''
  if (customerOrderCode) query += `customerOrderCode=${customerOrderCode}&`
  if (deliveryDateFrom) query += `deliveryDateFrom=${deliveryDateFrom}&deliveryDateTo=${deliveryDateTo}&`
  if (partnerExpectedCollectionDateFrom) query += `partnerExpectedCollectionDateFrom=${partnerExpectedCollectionDateFrom}&partnerExpectedCollectionDateTo=${partnerExpectedCollectionDateTo}&`
  if (status) query += `status=${status}&`
  if (storeCode) query += `storeCode=${storeCode}&`
  if (supplierOrderCode) query += `supplierOrderCode=${supplierOrderCode}&`

  return axios.get(`${EDF_DELIVERY_DOWNLOAD}?${query}&queryParams= `, { responseType: 'blob', params })
}

export default {
  getCustomerOrders,
  putOrderChanges,
  getDownload,
  uploadImg,
  putEditOrdersStatus,
  addReschedule,
  addIncidence,
  putRescheduleDateTime,
  uploadProofDeliveries,
  getEdfOrders,
  getdownloadForEdf
}



// WEBPACK FOOTER //
// ./src/repository/api/orders.js